import { getItemsIds } from '../../../utils/common'
import { getRequestTitle } from '../../Request'

export function getAttachRequestsPayload(requests) {
  return { requests: getItemsIds(requests) }
}

export function getServiceRequestListItemProps(value) {
  return {
    description: value.building?.title,
    isArchived: value.archived,
    status: value.status,
    text: getRequestTitle({
      requestNumber: value.request_no,
      title: value.title,
    }),
    value: value.id,
  }
}
